import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CarouselsService} from '../../networking/services/cms/carousels.service';
import {Product} from '../../networking/models/product/responses/product.class';
import {LocationManager} from '../location/location.manager';
import {ssrTokens} from '../../../../environments/colombia/ssr-tokens';
import { LocalStorageManager } from '../local-storage/local-storage.manager';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CarouselsManager {
  private ssrTokens = ssrTokens;
  public isBrowser;
  constructor(private carouselService: CarouselsService,
              private locationManager: LocationManager,
              private lsm: LocalStorageManager,
              @Inject(PLATFORM_ID) platformId
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  getHighlighted(params?): Observable<any> {
    params = {
      ...params, 
      idCustomerWebSafe : ( this.isBrowser || !this.lsm.get('customer') ) ? ssrTokens?.idCustomerWebSafe: this.lsm.get('customer')?.idCustomerWebSafe,
      token : ( this.isBrowser || !this.lsm.get('customer') ) ? ssrTokens?.token.token: this.lsm.get('customer')?.token.token,
      tokenIdWebSafe : ( this.isBrowser || !this.lsm.get('customer') ) ? ssrTokens?.token.tokenIdWebSafe: this.lsm.get('customer')?.token.tokenIdWebSafe,
      idStoreGroup: this.locationManager.getIdStoreGroup()
    };
    return this.carouselService.getHighlighted(params)
      .pipe(map(response => {
        if (response.highlightList) {
          return response.highlightList.map(item => {
            if (item.type === 'UNIQUE') {
              item = new Product(item.product[0]);
            } else {
              item.url = `/destacados/${item.id}`;
              item = new Product(item);
            }
            return item;
          });
        }
        return [];
      }));
  }

  getSuggested(): Observable<any> {
    return this.carouselService.getSuggested({idStoreGroup: this.locationManager.getIdStoreGroup()})
      .pipe(map(response => {
        if (response.suggestsList) {
         return response.suggestsList.map(item => {
            if (item.type === 'UNIQUE') {
              item = new Product(item.product[0]);
            } else {
              item.url = `/sugeridos/${item.id}`;
              item = new Product(item);
            }
            return item;
          });
        }
        return [];
      }));
  }
}
